<template>
  <Modal
    hide-close-button
    :modal-style="{ width: '600px' }"
    persistent
    :title="title"
  >
    <div class="q-py-sm">
      <QInput
        v-model="notes"
        filled
        :label="label"
        square
        type="textarea"
      />
      <div class="row justify-end">
        <QBtn
          label="Cancel"
          no-caps
          @click="cancel"
        />
        <QBtn
          class="q-mx-md"
          color="black"
          label="Save"
          no-caps
          @click="save"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "InvoiceNotesModal",
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ["cancel", "save"],
  data() {
    return {
      notes: null,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.notes = this.modelValue;
      },
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      this.$emit("save", this.notes);
    },
  },
};
</script>
